module.exports = __webpack_public_path__ + "static/img/tips.bd06941.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shop/tips.png
// module id = Jv4i
// module chunks = 1